import axios from "axios";
import { Dispatch } from "redux";
import {
  ADD_CONTACT_US,
  ADD_CONTACT_US_SUCCESS,
  ADD_CONTACT_US_FAILURE,
  RESET_CONTACT_US,
  ContactUsActionTypes,
} from "../types/contactTypes";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

API.defaults.withCredentials = true;

export const addContactUs =
  (data: any) => async (dispatch: Dispatch<ContactUsActionTypes>) => {
    try {
      dispatch({ type: ADD_CONTACT_US, payload: [] });

      const response = await API.post("/customer_enquiries", data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (response.status) {
        dispatch({ type: ADD_CONTACT_US_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: ADD_CONTACT_US_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: ADD_CONTACT_US_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const resetContactUs =
  () => (dispatch: Dispatch<ContactUsActionTypes>) => {
    dispatch({ type: RESET_CONTACT_US });
  };
